import { render, staticRenderFns } from "./Statuts.vue?vue&type=template&id=3e354324"
import script from "./Statuts.vue?vue&type=script&lang=js"
export * from "./Statuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports